import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DexTemplate } from '@app/modules/configuration/configuration.types';
import { environment } from '@root/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TemplatesService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/dex-wrapper/templates`;

  listTemplates() {
    return this.http.get<DexTemplate[]>(`${this.apiUrl}?State=All`);
  }

  getTemplate(id: string) {
    return this.http.get<DexTemplate>(`${this.apiUrl}/${id}`);
  }

  createTemplate(name: string): Observable<{ id: string }> {
    return this.http.post<{ id: string }>(`${this.apiUrl}`, { name });
  }

  cloneTemplate(id: string, name: string): Observable<{ id: string }> {
    return this.http.post<{ id: string }>(`${this.apiUrl}/${id}/clone`, {
      name,
    });
  }

  updateTemplate(id: string, name: string): Observable<{ id: string }> {
    return this.http.put<{ id: string }>(`${this.apiUrl}/${id}`, {
      name,
    });
  }

  reactivateTemplate(id: string) {
    return this.http.patch(`${this.apiUrl}/${id}/reactivate`, {});
  }

  deactivateTemplate(id: string) {
    return this.http.patch(`${this.apiUrl}/${id}/deactivate`, {});
  }

  refreshTranslations(): Observable<void> {
    return this.http.post<void>(
      `${environment.apiUrl}/dex-wrapper/translations/refresh`,
      {}
    );
  }
}
